module.exports = {
  cxApiParams: {
    anonClientId: "cr_web",
  },
  datadog: {
    applicationId: "cd93f32f-4608-4162-b03d-f322ebf425e3",
    clientToken: "pub02611aa18871dcd1cce1d524a76e4659",
    site: "us5.datadoghq.com",
    service: "cr-news",
    sessionSampleRate: 20,
    premiumSampleRate: 0,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  },
};
